import { render, staticRenderFns } from "./FactoryListAddNew.vue?vue&type=template&id=33fbdc55"
import script from "./FactoryListAddNew.vue?vue&type=script&lang=js"
export * from "./FactoryListAddNew.vue?vue&type=script&lang=js"
import style0 from "./FactoryListAddNew.vue?vue&type=style&index=0&id=33fbdc55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports